module.exports = __webpack_public_path__ + "img/img_logo@2x.be432e64.png";